import Game from '../../../Game';
import TimerSystem from '../TimerSystem';
import { IGameState } from '../../../State/Game/IGameState';
import DateHelper from '../../../Utility/DateHelper';

export default class Timer {
    public format: string = 'hh:mm:ss';
    public duration: number = 0;
    private cleanUp: null | (() => void) = null;
    constructor(autoStart: boolean = true) {
        if (autoStart) {
            this.start();
        }
    }
    public update(state: IGameState): void {}
    public onUpdate(state: IGameState = Game.store.getState()): void {}
    public complete(state: IGameState): void {}
    public isCompleted(state: IGameState = Game.store.getState()): boolean {
        return false;
    }
    public getDate(state: IGameState = Game.store.getState()): Date {
        return null;
    }
    public canContinue(): boolean {
        return false;
    }

    public stop() {
        this.cleanUp?.();
        this.cleanUp = null;
    }
    public start() {
        this.stop();
        this.cleanUp = TimerSystem.addTimer(this);
    }
    public getFormattedCountdown(state: IGameState) {
        const date = this.getDate(state);
        let timeRemaining = 0;
        
        if (date !== null)
            timeRemaining = (date.getTime() + this.duration) - DateHelper.now.getTime();

        return DateHelper.format(timeRemaining < 0 ? 0 : timeRemaining, this.format);
    }
}
